(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["milldue-kateg"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tiamont-milldue')) {
  customElements.define('tiamont-milldue', class extends HTMLElement {
    connectedCallback() {
      if (this.tmController) return;
      this.tmController = new AbortController();
      this.tmAnimations = new Set();
      this.tmSeen = new WeakSet();
      this.tmReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.tmDuration = Math.min(1400, Math.max(400, Number(this.dataset.tmDuration) || 900));
      const signal = this.tmController.signal;
      const enabled = () => this.dataset.tmMotion !== 'false' && !this.tmReduced.matches;
      const parallax = this.querySelector('[data-tm-parallax-image]');
      this.tmParallaxShift = 0;
      const paintParallax = () => {
        this.tmParallaxFrame = 0;
        if (!parallax) return;
        if (!enabled() || this.dataset.tmParallax === 'false') {
          parallax.style.removeProperty('--tm-parallax-y');
          this.tmParallaxShift = 0;
          return;
        }
        const rect = parallax.getBoundingClientRect();
        const top = rect.top - this.tmParallaxShift;
        const viewport = window.innerHeight;
        if (top > viewport + 40 || top + rect.height < -40) return;
        const progress = Math.max(-1, Math.min(1, (viewport / 2 - top - rect.height / 2) / ((viewport + rect.height) / 2)));
        const distance = window.matchMedia('(max-width: 649px)').matches ? 12 : 24;
        this.tmParallaxShift = progress * distance;
        parallax.style.setProperty('--tm-parallax-y', `${this.tmParallaxShift.toFixed(2)}px`);
      };
      const queueParallax = () => {
        if (!this.tmParallaxFrame) this.tmParallaxFrame = requestAnimationFrame(paintParallax);
      };
      window.addEventListener('scroll', queueParallax, { passive: true, signal });
      window.addEventListener('resize', queueParallax, { passive: true, signal });
      const animate = (element, frames, delay = 0, duration = this.tmDuration) => {
        if (!enabled() || typeof element.animate !== 'function') return;
        const animation = element.animate(frames, { duration, delay, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
        this.tmAnimations.add(animation);
        animation.finished.then(() => this.tmAnimations.delete(animation), () => this.tmAnimations.delete(animation));
      };
      const reveal = (element) => {
        if (this.tmSeen.has(element)) return;
        this.tmSeen.add(element);
        let delay = 0;
        const group = element.parentElement;
        if (group?.hasAttribute('data-tm-stagger') && window.matchMedia('(min-width: 650px)').matches) {
          const siblings = [...group.children];
          const row = siblings.filter(node => Math.abs(node.offsetTop - element.offsetTop) < 8);
          delay = Math.max(0, row.indexOf(element)) * 110;
        }
        const divider = element.classList.contains('tm-transition');
        animate(element, divider ? [{ opacity: 0, transform: 'scaleX(.65)' }, { opacity: 1, transform: 'scaleX(1)' }] : [{ opacity: 0, transform: 'translateY(30px)' }, { opacity: 1, transform: 'translateY(0)' }], delay);
        if (element.classList.contains('tm-detail')) {
          const frame = element.querySelector('figure');
          const photo = frame?.querySelector('img');
          const light = frame?.querySelector('.tm-detail__light');
          if (frame) animate(frame, [{ clipPath: 'inset(8% 0 8% 0)' }, { clipPath: 'inset(0)' }], delay, this.tmDuration + 200);
          if (photo) animate(photo, [{ transform: 'scale(1.07)', filter: 'brightness(.85)' }, { transform: 'scale(1)', filter: 'brightness(1)' }], delay, this.tmDuration + 500);
          if (light) animate(light, [{ transform: 'translateX(-100%)', opacity: 0 }, { transform: 'translateX(0)', opacity: 0.7, offset: 0.45 }, { transform: 'translateX(100%)', opacity: 0 }], delay + 180, this.tmDuration + 450);
        }
      };
      const start = () => {
        this.tmObserver?.disconnect();
        if (!enabled() || !('IntersectionObserver' in window)) return;
        this.tmObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            reveal(entry.target);
            this.tmObserver.unobserve(entry.target);
          });
        }, { threshold: 0.06, rootMargin: '0px 0px -24px 0px' });
        this.querySelectorAll('[data-tm-reveal]').forEach(element => {
          if (!this.tmSeen.has(element)) this.tmObserver.observe(element);
        });
      };
      this.querySelectorAll('.tm-hero__copy > *').forEach((element, index) => {
        animate(element, [{ opacity: 0, transform: 'translateY(22px)' }, { opacity: 1, transform: 'translateY(0)' }], index * 85);
      });
      const hero = this.querySelector('.tm-hero__visual > img');
      if (hero) animate(hero, [{ opacity: 0.35, transform: 'scale(1.055)' }, { opacity: 1, transform: 'scale(1)' }], 0, this.tmDuration + 400);
      start();
      queueParallax();
      this.tmReduced.addEventListener('change', () => {
        this.tmAnimations.forEach(animation => animation.cancel());
        start();
        queueParallax();
      }, { signal });
      this.addEventListener('click', event => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        const anchor = event.target.closest('a[href]');
        if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return;
        const url = new URL(anchor.href, location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
        let id;
        try { id = decodeURIComponent(url.hash.slice(1)); } catch { return; }
        const target = document.getElementById(id);
        if (!target || !this.contains(target)) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: enabled() ? 'smooth' : 'auto', block: 'start' });
        const focusTarget = target.querySelector('h2') || target;
        focusTarget.setAttribute('tabindex', '-1');
        focusTarget.focus({ preventScroll: true });
        if (location.hash !== url.hash) history.pushState(null, '', url.hash);
      }, { signal });
      this.querySelectorAll('.tm-faq details').forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open) animate(details.querySelector('.tm-faq__answer'), [{ opacity: 0, transform: 'translateY(-7px)' }, { opacity: 1, transform: 'translateY(0)' }], 0, 380);
        }, { signal });
      });
      this.addEventListener('shopify:block:select', event => {
        event.target.getAnimations?.({ subtree: true }).forEach(animation => animation.cancel());
      }, { signal });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.tmParallaxFrame);
      this.tmObserver?.disconnect();
      this.tmAnimations?.forEach(animation => animation.cancel());
      this.tmController?.abort();
      this.tmController = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiamont-abyss-bmantel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tiamont-robes')) {
  customElements.define('tiamont-robes', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const on = (node, event, callback, options = {}) => node?.addEventListener(event, callback, { ...options, signal: this.events.signal });
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const film = this.querySelector('[data-film]');
      const video = film?.querySelector('video');
      const controls = film?.querySelector('[data-controls]');
      const play = controls?.querySelector('[data-play]');
      const fullscreen = controls?.querySelector('[data-fullscreen]');
      const update = () => {
        if (!video || !play) return;
        const playing = !video.paused && !video.ended;
        const label = playing ? play.dataset.pauseLabelText : play.dataset.playLabelText;
        play.setAttribute('aria-label', label);
        play.querySelector('[data-play-label]').textContent = label;
        film.toggleAttribute('data-playing', playing);
      };
      if (video && controls && play) {
        video.controls = false;
        on(play, 'click', async () => {
          try {
            if (video.paused || video.ended) {
              if (video.ended) video.currentTime = 0;
              await video.play();
            } else video.pause();
          } catch { video.controls = true; }
        });
        ['play', 'pause', 'ended'].forEach(event => on(video, event, update));
        on(video, 'error', () => { film.querySelector('[data-video-error]').hidden = false; update(); });
        if (fullscreen) {
          fullscreen.hidden = !film.requestFullscreen || !document.fullscreenEnabled;
          on(fullscreen, 'click', async () => {
            try { if (document.fullscreenElement === film) await document.exitFullscreen(); else await film.requestFullscreen(); } catch {}
          });
          on(document, 'fullscreenchange', () => fullscreen.setAttribute('aria-label', document.fullscreenElement === film ? fullscreen.dataset.exit : fullscreen.dataset.enter));
        }
        controls.hidden = false;
        update();
      }
      const panels = [...this.querySelectorAll('[data-parallax]')];
      const visible = new Set();
      const updateParallax = () => {
        this.frame = null;
        if (reduced.matches || window.innerWidth < 750) return;
        visible.forEach(panel => {
          const box = panel.getBoundingClientRect();
          const offset = Math.max(-14, Math.min(14, (innerHeight / 2 - box.top - box.height / 2) * 0.035));
          panel.style.setProperty('--tmr-parallax', offset.toFixed(1) + 'px');
        });
      };
      const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(updateParallax); };
      const pauseFilm = () => { if (video && !document.fullscreenElement) video.pause(); };
      if ('IntersectionObserver' in window) {
        this.parallaxObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target); });
          schedule();
        });
        panels.forEach(panel => this.parallaxObserver.observe(panel));
        const revealNodes = [...this.querySelectorAll('[data-reveal]')];
        if (!reduced.matches) {
          this.classList.add('tmr-reveal-ready');
          this.revealObserver = new IntersectionObserver(entries => {
            entries.filter(entry => entry.isIntersecting)
              .sort((a, b) => revealNodes.indexOf(a.target) - revealNodes.indexOf(b.target))
              .forEach((entry, index) => {
                entry.target.style.setProperty('--tmr-reveal-delay', Math.min(index * 0.07, 0.35) + 's');
                entry.target.classList.add('tmr-revealing');
                this.revealObserver.unobserve(entry.target);
              });
          }, { threshold: 0.04, rootMargin: '0px 0px -7% 0px' });
          revealNodes.forEach(node => this.revealObserver.observe(node));
        }
        const qualityPoints = [...this.querySelectorAll('[data-quality-reveal]')];
        if (!reduced.matches) {
          this.querySelectorAll('[data-quality-points]').forEach(group => group.classList.add('tmr-quality-ready'));
          this.qualityObserver = new IntersectionObserver(entries => {
            entries.filter(entry => entry.isIntersecting)
              .sort((a, b) => qualityPoints.indexOf(a.target) - qualityPoints.indexOf(b.target))
              .forEach((entry, index) => {
                entry.target.style.setProperty('--tmr-quality-delay', (index * (entry.target.closest('.tmr-material-grid') ? 0.24 : 0.18)) + 's');
                entry.target.classList.add('tmr-quality-visible');
                this.qualityObserver.unobserve(entry.target);
              });
          }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });
          qualityPoints.forEach(node => this.qualityObserver.observe(node));
        }
        if (film) {
          this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) pauseFilm(); }), { threshold: 0.1 });
          this.videoObserver.observe(film);
        }
      }
      on(window, 'scroll', schedule, { passive: true });
      on(window, 'resize', () => { panels.forEach(panel => panel.style.removeProperty('--tmr-parallax')); schedule(); }, { passive: true });
      on(reduced, 'change', () => { panels.forEach(panel => panel.style.removeProperty('--tmr-parallax')); if (reduced.matches) { this.classList.remove('tmr-reveal-ready'); this.revealObserver?.disconnect(); this.querySelectorAll('[data-quality-points]').forEach(group => group.classList.remove('tmr-quality-ready')); this.qualityObserver?.disconnect(); } schedule(); });
      on(document, 'visibilitychange', () => { if (document.hidden) pauseFilm(); });
    }
    disconnectedCallback() {
      this.classList.remove('tmr-reveal-ready');
      this.querySelectorAll('[data-quality-points]').forEach(group => group.classList.remove('tmr-quality-ready'));
      this.events?.abort();
      this.events = null;
      this.parallaxObserver?.disconnect();
      this.revealObserver?.disconnect();
      this.videoObserver?.disconnect();
      this.qualityObserver?.disconnect();
      this.querySelector('video')?.pause();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiamont-bmantel-prd"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tiamont-robe-finale')) {
  customElements.define('tiamont-robe-finale', class extends HTMLElement {
    connectedCallback() {
      if (!document.referrer) return;
      try {
        const source = new URL(document.referrer);
        const collection = new URL(this.dataset.robesUrl, window.location.href);
        const pathname = value => value.replace(/\/+$/, '') || '/';
        if (source.origin !== window.location.origin || pathname(source.pathname) !== pathname(collection.pathname)) return;
        for (const link of this.querySelectorAll('[data-robe-navigation]')) {
          link.href = source.href;
          link.querySelector('[data-navigation-label]').textContent = link.dataset.backLabel;
          link.querySelector('[data-navigation-icon]').textContent = '←';
        }
      } catch {}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiamont-designbadm"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tiamont-design')){
  customElements.define('tiamont-design',class extends HTMLElement{
    connectedCallback(){
      this.cleanup();
      this.abort=new AbortController();const signal=this.abort.signal;
      this.classList.add('is-enhanced');
      const reduced=matchMedia('(prefers-reduced-motion: reduce)');
      const cards=[...this.querySelectorAll('[data-card]')];
      const filters=this.querySelector('[data-filters]');const count=this.querySelector('[data-count]');
      const showTone=tone=>{
        let visible=0;
        cards.forEach(card=>{card.hidden=tone!=='all'&&card.dataset.tone!==tone;if(!card.hidden)visible++});
        filters?.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item.dataset.tone===tone)));
        if(count)count.textContent=count.dataset.template.replace('__COUNT__',String(visible));
        const empty=this.querySelector('[data-filter-empty]');if(empty)empty.hidden=visible!==0;
      };
      if(filters){
        filters.hidden=false;
        filters.addEventListener('click',event=>{const button=event.target.closest('button[data-tone]');if(button)showTone(button.dataset.tone)},{signal});
      }
      const heroNumber=this.querySelector('[data-hero-number]');
      heroNumber?.addEventListener('click',event=>{
        const target=document.getElementById(heroNumber.hash.slice(1));if(!target)return;
        event.preventDefault();showTone('all');target.focus({preventScroll:true});
        target.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'start'});
      },{signal});
      const detail=this.querySelector('[data-detail-motion]');
      const updateDetail=()=>{
        this.motionFrame=0;if(!detail||reduced.matches)return;
        const rect=detail.getBoundingClientRect();if(rect.bottom<0||rect.top>innerHeight)return;
        const progress=Math.max(0,Math.min(1,(innerHeight-rect.top)/(innerHeight+rect.height)));
        detail.style.setProperty('--tdb-detail-y',((progress-.5)*12).toFixed(2));
        detail.style.setProperty('--tdb-detail-zoom',(progress*.025).toFixed(4));
      };
      const queueDetail=()=>{if(detail&&!reduced.matches&&!this.motionFrame)this.motionFrame=requestAnimationFrame(updateDetail)};
      const processTrack=this.querySelector('[data-process-track]');
      const processSteps=processTrack?[...processTrack.children]:[];
      const visibleSteps=new Set(),playedSteps=new Set();
      const clearProcess=(reset=false)=>{
        clearTimeout(this.processTimer);this.processTimer=0;
        processTrack?.classList.remove('is-process-running');
        processSteps.forEach(step=>{
          step.classList.remove('is-step-active');
          if(reset)step.classList.remove('is-step-complete');
        });
        if(reset)playedSteps.clear();
      };
      const runProcessStep=()=>{
        this.processTimer=0;
        if(reduced.matches||document.hidden||!visibleSteps.size){clearProcess();return}
        const step=processSteps.find(item=>visibleSteps.has(item)&&!playedSteps.has(item));
        if(!step){processTrack?.classList.remove('is-process-running');return}
        playedSteps.add(step);step.classList.add('is-step-active');
        this.processTimer=setTimeout(()=>{
          step.classList.remove('is-step-active');step.classList.add('is-step-complete');
          runProcessStep();
        },1100);
      };
      const syncProcess=()=>{
        if(reduced.matches||document.hidden||!visibleSteps.size){clearProcess();return}
        if(!this.processTimer&&processSteps.some(step=>visibleSteps.has(step)&&!playedSteps.has(step))){
          processTrack?.classList.add('is-process-running');
          this.processTimer=setTimeout(runProcessStep,350);
        }
      };
      document.addEventListener('visibilitychange',syncProcess,{signal});
      const configureMotion=()=>{
        this.reveals?.disconnect();this.lineObserver?.disconnect();this.processObserver?.disconnect();this.processBoundaryObserver?.disconnect();
        clearProcess(true);visibleSteps.clear();
        const enabled=!reduced.matches&&'IntersectionObserver'in window;this.classList.toggle('is-motion-enabled',enabled);
        if(!enabled){
          this.querySelectorAll('.is-entering').forEach(el=>el.classList.remove('is-entering'));
          detail?.style.removeProperty('--tdb-detail-y');detail?.style.removeProperty('--tdb-detail-zoom');return;
        }
        this.reveals=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-entering');this.reveals.unobserve(entry.target)}})},{threshold:.12});
        this.querySelectorAll('[data-reveal]').forEach(node=>this.reveals.observe(node));
        this.lineObserver=new IntersectionObserver(entries=>{entries.forEach(entry=>entry.target.closest('[data-card]')?.classList.toggle('is-line-visible',entry.isIntersecting))},{threshold:.5,rootMargin:'0px 0px -24px 0px'});
        this.querySelectorAll('.tdb__ctype').forEach(node=>this.lineObserver.observe(node));queueDetail();
        this.processBoundaryObserver=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{if(!entry.isIntersecting)clearProcess(true)});
        });
        if(processTrack)this.processBoundaryObserver.observe(processTrack);
        this.processObserver=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{
            const step=entry.target.parentElement;
            if(entry.isIntersecting&&entry.intersectionRatio>=.6)visibleSteps.add(step);else visibleSteps.delete(step);
          });syncProcess();
        },{threshold:[0,.6],rootMargin:'0px 0px -24px 0px'});
        processSteps.forEach(step=>{const number=step.querySelector('.tdb__step-number');if(number)this.processObserver.observe(number)});
      };
      configureMotion();
      window.addEventListener('scroll',queueDetail,{signal,passive:true});window.addEventListener('resize',queueDetail,{signal,passive:true});
      const video=this.querySelector('video');const toggle=this.querySelector('[data-video-toggle]');
      if(video&&toggle){
        const frame=this.querySelector('[data-video-frame]');const controls=this.querySelector('[data-video-controls]');
        const play=this.querySelector('[data-video-play]');const fullscreen=this.querySelector('[data-video-fullscreen]');const status=this.querySelector('[data-video-status]');
        video.controls=false;video.muted=true;toggle.hidden=false;if(controls)controls.hidden=false;
        const label=()=>{
          const text=video.paused?toggle.dataset.play:toggle.dataset.pause;toggle.textContent=text;play?.setAttribute('aria-label',text);
          const playIcon=play?.querySelector('[data-play-icon]');const pauseIcon=play?.querySelector('[data-pause-icon]');
          if(playIcon)playIcon.toggleAttribute('hidden',!video.paused);if(pauseIcon)pauseIcon.toggleAttribute('hidden',video.paused);
        };
        const playVideo=async(manual=false)=>{try{await video.play();if(status)status.hidden=true}catch{if(manual&&status)status.hidden=false}};
        const toggleVideo=()=>{if(video.paused)playVideo(true);else video.pause()};
        video.addEventListener('play',label,{signal});video.addEventListener('pause',label,{signal});label();
        toggle.addEventListener('click',toggleVideo,{signal});play?.addEventListener('click',toggleVideo,{signal});
        if(fullscreen&&frame){
          fullscreen.hidden=!(frame.requestFullscreen||frame.webkitRequestFullscreen||video.webkitEnterFullscreen);
          fullscreen.addEventListener('click',async()=>{
            try{
              if(document.fullscreenElement===frame)await document.exitFullscreen();
              else if(document.webkitFullscreenElement===frame)document.webkitExitFullscreen();
              else if(frame.requestFullscreen)await frame.requestFullscreen();
              else if(frame.webkitRequestFullscreen)frame.webkitRequestFullscreen();
              else video.webkitEnterFullscreen();
            }catch{if(video.webkitEnterFullscreen)try{video.webkitEnterFullscreen()}catch{}}
          },{signal});
          const fullLabel=()=>fullscreen.setAttribute('aria-label',document.fullscreenElement===frame||document.webkitFullscreenElement===frame?fullscreen.dataset.exit:fullscreen.dataset.enter);
          document.addEventListener('fullscreenchange',fullLabel,{signal});document.addEventListener('webkitfullscreenchange',fullLabel,{signal});
        }
        let started=false;
        if('IntersectionObserver'in window){
          this.videoObserver=new IntersectionObserver(entries=>{
            entries.forEach(entry=>{
              if(entry.isIntersecting){
                if(!started&&this.dataset.autoplay==='true'&&!reduced.matches&&!navigator.connection?.saveData){started=true;playVideo()}
              }else if(!video.paused)video.pause();
            });
          },{threshold:.35});this.videoObserver.observe(video);
        }
        document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause()},{signal});
      }
      reduced.addEventListener('change',()=>{configureMotion();if(reduced.matches)video?.pause()},{signal});
    }
    cleanup(){clearTimeout(this.processTimer);this.processTimer=0;this.abort?.abort();this.reveals?.disconnect();this.lineObserver?.disconnect();this.processObserver?.disconnect();this.processBoundaryObserver?.disconnect();this.videoObserver?.disconnect();if(this.motionFrame)cancelAnimationFrame(this.motionFrame);this.motionFrame=0}
    disconnectedCallback(){this.cleanup();this.querySelector('video')?.pause()}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiamont-extrav-badm"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tiamont-badmoebel')) {
  customElements.define('tiamont-badmoebel', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.videoObserver?.disconnect();
      this.cardObserver?.disconnect();
      this.parallaxObserver?.disconnect();
      this.planObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const on = (element, event, handler) => element?.addEventListener(event, handler, options);
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const planItems = [...this.querySelectorAll('[data-plan-reveal]')];
      const observePlan = () => {
        if (reduced.matches || !('IntersectionObserver' in window)) return;
        this.planObserver?.disconnect();
        this.planObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-entering');
          this.planObserver.unobserve(entry.target);
        }), { threshold: 0.12 });
        planItems.filter(item => !item.classList.contains('is-entering')).forEach(item => this.planObserver.observe(item));
      };
      observePlan();
      this.setAttribute('data-ready', '');
      const cards = [...this.querySelectorAll('[data-card]')];
      const palette = this.querySelector('[data-palette]');
      const count = this.querySelector('[data-count]');
      let activeFilter = 'all';
      const filter = () => {
        let visible = 0;
        cards.forEach(card => {
          card.hidden = activeFilter === 'stone' ? card.dataset.material !== 'stone' : activeFilter !== 'all' && card.dataset.tone !== activeFilter;
          if (!card.hidden) visible++;
        });
        palette?.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === activeFilter)));
        if (count) count.textContent = count.dataset.countPattern.replace('[count]', String(visible));
        const empty = this.querySelector('[data-empty]');
        if (empty) empty.hidden = visible !== 0;
      };
      if (palette && cards.length) {
        palette.hidden = false;
        filter();
        on(palette, 'click', event => {
          const button = event.target.closest('button[data-filter]');
          if (button) { activeFilter = button.dataset.filter; filter(); }
        });
      }
      on(this.querySelector('[data-reset]'), 'click', () => {
        activeFilter = 'all'; filter();
        palette?.querySelector('button')?.focus();
      });
      const dialog = this.querySelector('dialog');
      let lastLink;
      this.querySelectorAll('[data-lightbox]').forEach(link => on(link, 'click', event => {
        if (!dialog?.showModal || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        lastLink = link;
        const source = link.querySelector('img');
        const target = dialog.querySelector('img');
        target.src = link.href;
        target.alt = source.alt;
        dialog.querySelector('figcaption').textContent = link.closest('figure').querySelector('figcaption').textContent;
        dialog.showModal();
      }));
      on(dialog?.querySelector('[data-close]'), 'click', () => dialog.close());
      on(dialog, 'click', event => { if (event.target === dialog) dialog.close(); });
      on(dialog, 'close', () => lastLink?.focus());
      const videos = [...this.querySelectorAll('video')];
      videos.forEach(video => {
        const film = video.closest('.tm-bath__film');
        const controls = film.querySelector('[data-video-controls]');
        const play = controls?.querySelector('[data-play-toggle]');
        const fullscreen = controls?.querySelector('[data-fullscreen]');
        if (!controls || !play) return;
        const update = () => {
          const label = video.paused ? play.dataset.play : play.dataset.pause;
          play.setAttribute('aria-label', label);
          const text = play.querySelector('[data-play-label]');
          if (text) text.textContent = label;
          play.dataset.playing = String(!video.paused);
        };
        const toggle = () => {
          if (video.paused) {
            const source = video.querySelector('source[data-src]');
            if (source) {
              source.src = source.dataset.src;
              source.removeAttribute('data-src');
              video.load();
            }
            video.play().catch(update);
          }
          else video.pause();
        };
        video.controls = false;
        controls.hidden = false;
        film.dataset.customControls = '';
        on(play, 'click', toggle);
        on(video, 'click', toggle);
        on(video, 'play', () => { update(); videos.forEach(other => { if (other !== video) other.pause(); }); });
        on(video, 'pause', update);
        on(video, 'ended', update);
        on(video, 'error', () => { video.controls = true; controls.hidden = true; delete film.dataset.customControls; });
        update();
        if (fullscreen) {
          const standardFullscreen = Boolean(film.requestFullscreen && document.fullscreenEnabled);
          fullscreen.hidden = !standardFullscreen && !video.webkitEnterFullscreen;
          on(fullscreen, 'click', async () => {
            try {
              if (document.fullscreenElement === film) await document.exitFullscreen();
              else if (standardFullscreen) await film.requestFullscreen();
              else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
            } catch { if (video.webkitEnterFullscreen) { try { video.webkitEnterFullscreen(); } catch {} } }
          });
          on(document, 'fullscreenchange', () => fullscreen.setAttribute('aria-label', document.fullscreenElement === film ? fullscreen.dataset.exit : fullscreen.dataset.enter));
        }
      });
      if ('IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          const video = entry.target;
          if (!entry.isIntersecting && !document.fullscreenElement && !video.webkitDisplayingFullscreen) video.pause();
        }), { threshold: 0.15 });
        videos.forEach(video => this.videoObserver.observe(video));
        this.cardObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          const visible = entry.isIntersecting && !reduced.matches && !entry.target.hidden;
          entry.target.classList.toggle('is-lit', visible);
          if (visible) entry.target.classList.add('is-revealing');
        }), { threshold: 0.12 });
        cards.forEach(card => this.cardObserver.observe(card));
      }
      const panel = this.querySelector('[data-parallax]');
      let parallaxVisible = false;
      const updateParallax = () => {
        this.frame = null;
        if (!panel || reduced.matches) return;
        const box = panel.getBoundingClientRect();
        const offset = Math.max(-30, Math.min(30, (innerHeight / 2 - box.top - box.height / 2) * 0.065));
        panel.style.setProperty('--tm-parallax', offset.toFixed(1) + 'px');
      };
      const scheduleParallax = () => {
        if (parallaxVisible && !reduced.matches && !this.frame) this.frame = requestAnimationFrame(updateParallax);
      };
      if (panel && 'IntersectionObserver' in window) {
        this.parallaxObserver = new IntersectionObserver(entries => {
          parallaxVisible = entries[0].isIntersecting;
          scheduleParallax();
        });
        this.parallaxObserver.observe(panel);
        window.addEventListener('scroll', scheduleParallax, { ...options, passive: true });
        on(window, 'resize', scheduleParallax);
      }
      on(document, 'visibilitychange', () => { if (document.hidden) videos.forEach(video => video.pause()); });
      on(reduced, 'change', () => {
        if (reduced.matches) {
          videos.forEach(video => video.pause());
          cancelAnimationFrame(this.frame); this.frame = null;
          panel?.style.removeProperty('--tm-parallax');
          cards.forEach(card => card.classList.remove('is-lit', 'is-revealing'));
          this.planObserver?.disconnect();
          planItems.forEach(item => item.classList.remove('is-entering'));
        } else { scheduleParallax(); observePlan(); }
      });
    }
    disconnectedCallback() {
      this.events?.abort();
      this.videoObserver?.disconnect();
      this.cardObserver?.disconnect();
      this.parallaxObserver?.disconnect();
      this.planObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiamont-glasm-seo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tiamont-glasmosaike')) {
  customElements.define('tiamont-glasmosaike', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.events = new AbortController();
      const opt = { signal: this.events.signal };
      const on = (el, ev, fn, o) => el && el.addEventListener(ev, fn, Object.assign({}, opt, o || {}));
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      /* Einblenden, Parallax und Endlosanimationen nur auf Desktop mit Maus */
      const motion = !reduced.matches && matchMedia('(hover: hover) and (pointer: fine)').matches;

      /* ---------- Ereignisse für GA4 / dataLayer ---------- */
      const track = (name, extra) => {
        const data = Object.assign({ event: name, event_category: 'SICIS Glasmosaike', event_label: name }, extra || {});
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(data); } catch (e) {}
        try { if (typeof window.gtag === 'function') window.gtag('event', name, Object.assign({}, extra || {}, { event_category: 'SICIS Glasmosaike' })); } catch (e) {}
      };
      on(this, 'click', ev => {
        const hit = ev.target && ev.target.closest ? ev.target.closest('[data-track]') : null;
        if (hit) track(hit.getAttribute('data-track'));
      });

      /* ---------- Einblenden ---------- */
      const targets = [...this.querySelectorAll('[data-reveal]')];
      if (motion && 'IntersectionObserver' in window) {
        this.setAttribute('data-ready', '');
        this.reveal = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          this.reveal.unobserve(entry.target);
        }), { threshold: 0.12, rootMargin: '0px 0px -40px' });
        targets.forEach(el => this.reveal.observe(el));
      }

      /* ---------- Überschrift einzeilig halten ---------- */
      const h1 = this.querySelector('.tgl-h1__main');
      const fitH1 = () => {
        if (!h1 || !h1.parentElement) return;
        h1.style.fontSize = '';
        const room = Math.floor(h1.parentElement.getBoundingClientRect().width);
        if (!room) return;
        let size = parseFloat(getComputedStyle(h1).fontSize) || 0;
        let guard = 0;
        while (h1.scrollWidth > room + 1 && size > 18 && guard++ < 60) {
          size *= 0.97;
          h1.style.fontSize = size.toFixed(2) + 'px';
        }
      };
      fitH1();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitH1).catch(() => {});
      let fitW = innerWidth, fitT = 0;
      on(window, 'resize', () => {
        if (innerWidth === fitW) return;
        fitW = innerWidth;
        clearTimeout(fitT);
        fitT = setTimeout(fitH1, 120);
      });

      /* ---------- Film ---------- */
      const film = this.querySelector('[data-film]');
      const video = film && film.querySelector('video');
      if (video) {
        const controls = film.querySelector('[data-controls]');
        const play = controls && controls.querySelector('[data-play]');
        const full = controls && controls.querySelector('[data-fullscreen]');
        const label = controls && controls.querySelector('[data-play-label]');
        if (film.dataset.label && !video.getAttribute('aria-label')) video.setAttribute('aria-label', film.dataset.label);
        if (!video.id && play) video.id = play.getAttribute('aria-controls');
        video.controls = false;
        video.muted = true;
        video.setAttribute('playsinline', '');
        const sync = () => {
          if (!play) return;
          const text = video.paused ? play.dataset.labelPlay : play.dataset.labelPause;
          play.setAttribute('aria-label', text);
          if (label) label.textContent = text;
          play.dataset.playing = String(!video.paused);
        };
        const toggle = () => {
          if (video.paused) { const p = video.play(); if (p && p.catch) p.catch(sync); }
          else video.pause();
        };
        const loaded = () => film.setAttribute('data-loaded', 'true');
        if (video.getAttribute('poster') || video.readyState >= 2) loaded();
        on(video, 'loadeddata', loaded);
        on(video, 'canplay', loaded);
        setTimeout(loaded, 4000);
        on(play, 'click', toggle);
        on(video, 'click', toggle);
        on(video, 'play', () => { sync(); track('SICIS_GM_FILM_PLAY'); });
        on(video, 'pause', sync);
        on(video, 'ended', sync);
        on(video, 'error', () => { video.controls = true; loaded(); if (controls) controls.hidden = true; });
        sync();
        if (full) {
          const native = Boolean(film.requestFullscreen && document.fullscreenEnabled);
          full.hidden = !native && !video.webkitEnterFullscreen;
          on(full, 'click', async () => {
            try {
              if (document.fullscreenElement === film) await document.exitFullscreen();
              else if (native) await film.requestFullscreen();
              else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
            } catch (e) { try { if (video.webkitEnterFullscreen) video.webkitEnterFullscreen(); } catch (err) {} }
          });
          on(document, 'fullscreenchange', () => full.setAttribute('aria-label', document.fullscreenElement === film ? full.dataset.labelExit : full.dataset.labelEnter));
        }
        if ('IntersectionObserver' in window) {
          this.filmWatch = new IntersectionObserver(entries => entries.forEach(entry => {
            if (!entry.isIntersecting && !document.fullscreenElement && !video.webkitDisplayingFullscreen) video.pause();
          }), { threshold: 0.15 });
          this.filmWatch.observe(video);
        }
        on(document, 'visibilitychange', () => { if (document.hidden) video.pause(); });
      }

      /* ---------- Parallax: schwebende Steine und Bildebenen ---------- */
      if (motion) {
        const layers = [];
        this.querySelectorAll('[data-depth]').forEach(el => layers.push({ el, base: el.parentElement, k: parseFloat(el.dataset.depth) || 0, max: 90 }));
        this.querySelectorAll('[data-par]').forEach(el => layers.push({ el, base: el.parentElement, k: parseFloat(el.dataset.par) || 0, max: 26 }));
        const tick = () => {
          this.frame = 0;
          const vh = innerHeight;
          for (const l of layers) {
            const r = l.base.getBoundingClientRect();
            if (r.bottom < -200 || r.top > vh + 200) continue;
            const off = r.top + r.height / 2 - vh / 2;
            const y = Math.max(-l.max, Math.min(l.max, -off * l.k));
            l.el.style.setProperty('--py', y.toFixed(1) + 'px');
          }
        };
        const queue = () => { if (!this.frame) this.frame = requestAnimationFrame(tick); };
        if (layers.length) {
          on(window, 'scroll', queue, { passive: true });
          on(window, 'resize', queue);
          queue();
        }
      }

      /* ---------- Mengenrechner ---------- */
      const calc = this.querySelector('[data-calc]');
      if (calc) {
        const area = calc.querySelector('[data-calc-area]');
        const outM = calc.querySelector('[data-calc-m2]');
        const outS = calc.querySelector('[data-calc-sheets]');
        const lang = (document.documentElement.lang || 'de').slice(0, 2);
        const fmt = new Intl.NumberFormat(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        const SHEET = 0.295 * 0.295;
        const run = () => {
          const a = parseFloat(String(area.value).replace(',', '.'));
          const x = calc.querySelector('[data-calc-x]:checked');
          const pct = x ? parseFloat(x.value) : 10;
          if (!a || a <= 0) { outM.textContent = '–'; outS.textContent = '–'; return; }
          const need = Math.ceil(a * (1 + pct / 100) * 10) / 10;
          outM.textContent = fmt.format(need);
          outS.textContent = String(Math.ceil(need / SHEET));
        };
        on(area, 'input', run);
        calc.querySelectorAll('[data-calc-x]').forEach(r => on(r, 'change', run));
        run();
      }

      on(reduced, 'change', () => { if (reduced.matches) targets.forEach(el => el.classList.add('is-in')); });
    }
    cleanup() {
      if (this.events) this.events.abort();
      if (this.reveal) this.reveal.disconnect();
      if (this.filmWatch) this.filmWatch.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
    disconnectedCallback() {
      this.cleanup();
      this.querySelectorAll('video').forEach(v => v.pause());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiamont-landingpage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tiamont-suite')) {
    customElements.define('tiamont-suite', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.media = window.matchMedia('(prefers-reduced-motion: reduce)');
        const signal = this.abortController.signal;
        this.media.addEventListener('change', () => this.updateMotion(), { signal });
        document.addEventListener('shopify:block:select', event => {
          const block = event.target;
          if (!this.contains(block)) return;
          block.removeAttribute('data-pending');
          const detail = block.matches('details') ? block : block.querySelector('details');
          if (detail) detail.open = true;
        }, { signal });
        this.addEventListener('focusin', event => {
          const element = event.target.closest('[data-reveal]');
          if (element) element.removeAttribute('data-pending');
        }, { signal });
        this.closing = this.querySelector('.ts-closing');
        this.tsxTags = [...this.querySelectorAll('.ts-material__tag, .tsx-btn--hero')];
        this.parallaxAreas = [
          {element:this.closing,enabled:this.dataset.parallax === 'true'},
          ...[...this.querySelectorAll('.tsx-stage--img')].map(element => ({element,enabled:this.dataset.materialsParallax === 'true'}))
        ].filter(area => area.element);
        const scheduleParallax = () => this.updateParallax();
        window.addEventListener('scroll', scheduleParallax, { passive: true, signal });
        window.addEventListener('resize', scheduleParallax, { passive: true, signal });
        this.updateMotion();
        this.setupRise();
        this.fitHero();
        this.equalWorlds();
        this.setupHeroGo(signal);
      }
      /* Klick auf den Titelbild Button: der Diamant beschleunigt nach rechts,
         ab der halben Strecke schießt er mit Lichtgeschwindigkeit weiter und
         ist am rechten Rand aufgelöst, danach öffnet sich die neue Seite */
      setupHeroGo(signal) {
        const btn = this.querySelector('.tsx-btn--hero');
        const emb = btn && btn.querySelector('.tsx-emb');
        if (!emb) return;
        let anims = [];
        const reset = () => {
          anims.forEach(anim => anim.cancel());
          anims = [];
          btn.classList.remove('is-going');
          const trail = btn.querySelector('.tsx-go-trail');
          if (trail) trail.remove();
        };
        btn.addEventListener('click', event => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (this.dataset.motionActive !== 'true' || btn.target === '_blank' || !emb.animate) return;
          event.preventDefault();
          if (btn.classList.contains('is-going')) return;
          const start = emb.offsetLeft + emb.offsetWidth / 2;
          const dist = Math.max(0, btn.clientWidth - 8 - start);
          btn.classList.add('is-going');
          const trail = document.createElement('i');
          trail.className = 'tsx-go-trail';
          trail.setAttribute('aria-hidden', 'true');
          trail.style.left = start + 'px';
          trail.style.width = dist + 'px';
          btn.appendChild(trail);
          const time = 560;
          anims = [
            emb.animate([
              { transform: 'translateX(0) scale(1)', opacity: 1, filter: 'brightness(1)', offset: 0, easing: 'cubic-bezier(.55,0,.9,.55)' },
              { transform: `translateX(${dist * .5}px) scale(1)`, opacity: 1, filter: 'brightness(1.6)', offset: .78, easing: 'linear' },
              { transform: `translateX(${dist}px) scale(2.8,.35)`, opacity: 0, filter: 'brightness(2.6) blur(2px)', offset: 1 }
            ], { duration: time, fill: 'forwards' }),
            trail.animate([
              { transform: 'scaleX(.5)', opacity: 0, offset: 0 },
              { transform: 'scaleX(.5)', opacity: 0, offset: .78 },
              { transform: 'scaleX(.8)', opacity: 1, offset: .9 },
              { transform: 'scaleX(1)', opacity: 0, offset: 1 }
            ], { duration: time, fill: 'forwards' })
          ];
          const url = new URL(btn.href, location.href);
          setTimeout(() => {
            if (url.pathname === location.pathname && url.hash) {
              const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
              if (target) target.scrollIntoView({ behavior: 'smooth' });
              setTimeout(reset, 500);
            } else {
              location.href = url.href;
            }
          }, time + 40);
        }, { signal });
        window.addEventListener('pageshow', reset, { signal });
      }
      /* Titel im Titelbild bleibt in jeder Sprache zweizeilig: die Schrift
         wird nur verkleinert, wenn eine Zeile sonst umbrechen müsste */
      fitHero() {
        const h = this.querySelector('.tsx-glasscard .ts-hero__title');
        if (!h) return;
        let last = 0;
        const fit = () => {
          h.style.removeProperty('--tsx-hfit');
          const avail = h.clientWidth;
          const need = Math.max(...[...h.children].map(el => el.scrollWidth));
          if (avail && need > avail + 1) h.style.setProperty('--tsx-hfit', (avail / need * .985).toFixed(3));
        };
        fit();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
        if ('ResizeObserver' in window) {
          const ro = new ResizeObserver(entries => {
            const w = Math.round(entries[0].contentRect.width);
            if (w !== last) { last = w; fit(); }
          });
          ro.observe(h.parentElement);
          this.tsxObservers = this.tsxObservers || [];
          this.tsxObservers.push(ro);
        }
      }
      equalWorlds() {
        const grid = this.querySelector('.tsx-worlds .ts-world-grid');
        const caps = grid ? [...grid.querySelectorAll('.ts-world__caption')] : [];
        if (caps.length < 2) return;
        let last = 0;
        const run = () => {
          const parts = caps.map(c => [c.querySelector('.ts-kicker'), c.querySelector('h3')]);
          parts.flat().forEach(el => el && el.style.removeProperty('min-height'));
          const cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
          if (cols < 2) return;
          for (let i = 0; i < parts.length; i += cols) {
            const row = parts.slice(i, i + cols);
            [0, 1].forEach(k => {
              const h = Math.max(...row.map(r => r[k] ? parseFloat(getComputedStyle(r[k]).height) || 0 : 0));
              row.forEach(r => r[k] && r[k].style.setProperty('min-height', h + 'px'));
            });
          }
        };
        run();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
        if ('ResizeObserver' in window) {
          const ro = new ResizeObserver(entries => {
            const w = Math.round(entries[0].contentRect.width);
            if (w !== last) { last = w; run(); }
          });
          ro.observe(grid);
          this.tsxObservers = this.tsxObservers || [];
          this.tsxObservers.push(ro);
        }
      }
      /* Kopfkarten blenden weich ein, sobald sie gut im Bild sind, und beim
         erneuten Herunterscrollen wieder */
      setupRise() {
        const items = this.querySelectorAll('.tsx-rise');
        if (!items.length) return;
        if (this.riseObserver) this.riseObserver.disconnect();
        const on = this.dataset.motionActive === 'true' && 'IntersectionObserver' in window && !window.Shopify?.designMode;
        this.dataset.rise = on ? 'on' : 'off';
        if (!on) {
          items.forEach(el => el.classList.add('is-in'));
          return;
        }
        this.riseObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) entry.target.classList.add('is-in');
            else if (entry.boundingClientRect.top > 0) entry.target.classList.remove('is-in');
          });
        }, { rootMargin: '0px 0px -18% 0px', threshold: 0.15 });
        items.forEach(el => this.riseObserver.observe(el));
      }
      updateMotion() {
        if (this.observer) this.observer.disconnect();
        const enabled = this.dataset.motion === 'true' && !this.media.matches;
        this.dataset.motionActive = String(enabled);
        this.updateParallax(true);
        this.querySelectorAll('[data-pending]').forEach(element => element.removeAttribute('data-pending'));
        if (!enabled || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.removeAttribute('data-pending');
              this.observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.08 });
        this.querySelectorAll('[data-reveal]').forEach(element => {
          if (element.getBoundingClientRect().top > window.innerHeight + 30) {
            element.setAttribute('data-pending', '');
            this.observer.observe(element);
          }
        });
      }
      updateParallax(immediate = false) {
        if (!this.parallaxAreas) return;
        if (this.tsxTags) {
          const on = this.dataset.motionActive === 'true';
          const vh = innerHeight;
          this.tsxTags.forEach(tag => {
            if (!on) {
              tag.style.removeProperty('--tsx-spot');
              tag.style.removeProperty('--tsx-glow');
              return;
            }
            if (!tag.hasAttribute('data-glow-intro') && tag.classList.contains('tsx-btn--hero')) tag.setAttribute('data-glow-intro', '');
            const top = tag.getBoundingClientRect().top;
            const p = Math.min(1, Math.max(0, (vh * .92 - top) / (vh * .6)));
            tag.style.setProperty('--tsx-spot', (-130 + p * 360).toFixed(1) + '%');
            tag.style.setProperty('--tsx-glow', Math.max(0, 1 - Math.abs(p - .5) * 2.4).toFixed(3));
          });
        }
        const strength = Math.min(100, Math.max(0, Number(this.dataset.parallaxStrength) || 0)) / 100;
        const mobileFactor = matchMedia('(max-width: 749px)').matches ? 0.55 : 1;
        this.parallaxAreas.forEach(area => {
          const active = this.dataset.motionActive === 'true' && area.enabled;
          const rect = area.element.getBoundingClientRect();
          const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - rect.top - rect.height / 2) / ((innerHeight + rect.height) / 2)));
          area.target = active ? progress * 170 * strength * mobileFactor : 0;
          if (immediate || !active) area.current = area.target;
        });
        if (immediate) { this.applyParallax(); return; }
        if (!this.parallaxFrame) this.animateParallax();
      }
      animateParallax() {
        let moving = false;
        this.parallaxAreas.forEach(area => {
          const current = Number.isFinite(area.current) ? area.current : area.target;
          const distance = area.target - current;
          area.current = Math.abs(distance) < 0.1 ? area.target : current + distance * 0.18;
          if (area.current !== area.target) moving = true;
        });
        this.applyParallax();
        if (!moving) {
          this.parallaxFrame = null;
          return;
        }
        this.parallaxFrame = requestAnimationFrame(() => this.animateParallax());
      }
      applyParallax() {
        this.parallaxAreas.forEach(area => area.element.style.setProperty('--ts-parallax-y', area.current.toFixed(2) + 'px'));
      }
      disconnectedCallback() {
        (this.tsxObservers || []).forEach(io => io.disconnect());
        if (this.riseObserver) this.riseObserver.disconnect();
        if (this.parallaxFrame) cancelAnimationFrame(this.parallaxFrame);
        this.abortController?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiamont-sicis-glaswaschbecken"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tiamont-glaswaschbecken')) {
  customElements.define('tiamont-glaswaschbecken', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const on = (el, ev, fn) => el && el.addEventListener(ev, fn, options);

      /* ---------- Ereignisse für Littledata, GA4 und Shopify Analytics ---------- */
      const track = (name, extra) => {
        const data = Object.assign({ event: name, event_category: 'SICIS Glaswaschbecken', event_label: name }, extra || {});
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(data); } catch (e) {}
        try { if (typeof window.gtag === 'function') window.gtag('event', name, Object.assign({}, extra || {}, { event_category: 'SICIS Glaswaschbecken' })); } catch (e) {}
        try { if (window.analytics && typeof window.analytics.track === 'function') window.analytics.track(name, extra || {}); } catch (e) {}
        try { if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib && typeof window.ShopifyAnalytics.lib.track === 'function') window.ShopifyAnalytics.lib.track(name, extra || {}); } catch (e) {}
      };
      on(this, 'click', ev => {
        const hit = ev.target && ev.target.closest ? ev.target.closest('[data-track]') : null;
        if (!hit) return;
        const name = hit.getAttribute('data-track');
        if (!name) return;
        const colour = hit.dataset.colour;
        if (colour) {
          track('SICIS_GWB_FTR', { farbe: colour, farbcode: name.replace('SICIS_GWB_FTR_', '') });
          track(name, { farbe: colour });
          return;
        }
        track(name);
      });

      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.setAttribute('data-ready', '');

      /* ---------- Einblenden ---------- */
      const targets = [...this.querySelectorAll('[data-reveal]'), ...this.querySelectorAll('[data-card]')];
      if ('IntersectionObserver' in window) {
        this.reveal = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          this.reveal.unobserve(entry.target);
        }), { threshold: 0.12, rootMargin: '0px 0px -40px' });
        targets.forEach(el => this.reveal.observe(el));
      } else {
        targets.forEach(el => el.classList.add('is-in'));
      }

      /* ---------- Film ---------- */
      const video = this.querySelector('video');
      const film = video && video.closest('.tmg-film');
      if (video && film) {
        const controls = film.querySelector('[data-controls]');
        const play = controls && controls.querySelector('[data-play]');
        const full = controls && controls.querySelector('[data-fullscreen]');
        const label = controls && controls.querySelector('[data-play-label]');
        const sync = () => {
          if (!play) return;
          const text = video.paused ? play.dataset.labelPlay : play.dataset.labelPause;
          play.setAttribute('aria-label', text);
          if (label) label.textContent = text;
          play.dataset.playing = String(!video.paused);
          film.dataset.open = String(!video.paused);
        };
        const toggle = () => {
          if (video.paused) { const p = video.play(); if (p && p.catch) p.catch(sync); }
          else video.pause();
        };
        video.controls = false;
        const markLoaded = () => film.setAttribute('data-loaded', 'true');
        if (video.getAttribute('poster') || video.readyState >= 2) markLoaded();
        on(video, 'loadeddata', markLoaded);
        on(video, 'canplay', markLoaded);
        setTimeout(markLoaded, 4000);
        on(play, 'click', toggle);
        on(video, 'play', () => track('SICIS_GWB_PLAY'));
        on(video, 'click', toggle);
        on(video, 'play', sync);
        on(video, 'pause', sync);
        on(video, 'ended', sync);
        on(video, 'error', () => { video.controls = true; markLoaded(); if (controls) controls.hidden = true; });
        sync();
        if (full) {
          const native = Boolean(film.requestFullscreen && document.fullscreenEnabled);
          full.hidden = !native && !video.webkitEnterFullscreen;
          on(full, 'click', async () => {
            try {
              if (document.fullscreenElement === film) await document.exitFullscreen();
              else if (native) await film.requestFullscreen();
              else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
            } catch (e) { if (video.webkitEnterFullscreen) { try { video.webkitEnterFullscreen(); } catch (err) {} } }
          });
          on(document, 'fullscreenchange', () => full.setAttribute('aria-label', document.fullscreenElement === film ? full.dataset.labelExit : full.dataset.labelEnter));
        }
        if ('IntersectionObserver' in window) {
          this.filmWatch = new IntersectionObserver(entries => entries.forEach(entry => {
            if (!entry.isIntersecting && !document.fullscreenElement && !video.webkitDisplayingFullscreen) video.pause();
          }), { threshold: 0.15 });
          this.filmWatch.observe(video);
        }
        on(document, 'visibilitychange', () => { if (document.hidden) video.pause(); });
      }

      /* ---------- Farbfilter, Ausstellung, Farbkreise ---------- */
      const pick = sel => this.querySelector(sel);
      const anchor = pick('#tmg-produkte');
      const canFetch = Boolean(window.fetch && window.DOMParser && window.history && history.pushState);

      /* Die Überschrift bleibt einzeilig – notfalls wird sie verkleinert */
      const h1 = this.querySelector('.tmg-h1__main');
      const fitH1 = () => {
        if (!h1 || !h1.parentElement) return;
        const inner = h1.querySelector('[aria-hidden="true"]');
        if (!inner) return;
        h1.style.fontSize = '';
        const room = Math.floor(h1.parentElement.getBoundingClientRect().width);
        if (!room) return;
        let size = parseFloat(getComputedStyle(h1).fontSize) || 0;
        let guard = 0;
        while (inner.getBoundingClientRect().width > room && size > 16 && guard++ < 60) {
          size = size * 0.97;
          h1.style.fontSize = size.toFixed(2) + 'px';
        }
      };
      fitH1();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitH1).catch(() => {});
      let fitTimer = 0;
      on(window, 'resize', () => { clearTimeout(fitTimer); fitTimer = setTimeout(fitH1, 120); });

      const colourPicked = () => {
        try { return [...new URLSearchParams(location.search).keys()].some(key => key.indexOf('filter.') === 0); }
        catch (e) { return /[?&]filter\./.test(location.search); }
      };

      /* Ohne Farbparameter darf kein Farbkreis markiert sein */
      const syncSwatches = () => {
        if (colourPicked()) return;
        this.querySelectorAll('.tmg-swatch__link.is-active').forEach(link => {
          link.classList.remove('is-active');
          link.removeAttribute('aria-current');
        });
      };

      /* Alle Farbkreise zusammen einblenden, statt einen nach dem anderen */
      const paintSwatches = () => {
        const list = pick('.tmg-swatches');
        if (!list) return;
        const dots = [...list.querySelectorAll('[data-sw-img]')];
        if (!dots.length) { list.classList.add('is-ready'); return; }
        let open = dots.length, settled = false;
        const finish = () => {
          if (settled) return;
          settled = true;
          dots.forEach(dot => dot.style.setProperty('--sw-img', 'url("' + dot.dataset.swImg + '")'));
          list.classList.add('is-ready');
        };
        const tick = () => { if (--open <= 0) finish(); };
        dots.forEach(dot => { const img = new Image(); img.onload = tick; img.onerror = tick; img.src = dot.dataset.swImg; });
        setTimeout(finish, 2500);
      };
      paintSwatches();
      syncSwatches();

      /* Ausstellungsstücke ein- und ausblenden */
      const showToggle = pick('[data-show-toggle]');
      const applyShow = open => {
        const showGrid = pick('[data-show-grid]');
        const mainGrid = pick('[data-main-grid]');
        const pages = pick('[data-pagination]');
        if (!showGrid || !showToggle) return;
        showGrid.hidden = !open;
        if (mainGrid) mainGrid.hidden = open;
        if (pages) pages.hidden = open;
        showToggle.classList.toggle('is-active', open);
        showToggle.setAttribute('href', open ? showToggle.dataset.urlOff : showToggle.dataset.urlOn);
        if (open) showToggle.setAttribute('aria-current', 'true'); else showToggle.removeAttribute('aria-current');
        const label = showToggle.querySelector('[data-show-label]');
        if (label) label.textContent = open ? showToggle.dataset.labelOff : showToggle.dataset.labelOn;
        if (open) showGrid.querySelectorAll('.tmg-card').forEach(card => card.classList.add('is-in'));
      };
      const showWanted = () => {
        try { return new URLSearchParams(location.search).get('ausstellung') === '1'; }
        catch (e) { return /[?&]ausstellung=1(&|$)/.test(location.search); }
      };
      const stripped = url => {
        try {
          const u = new URL(url, location.href);
          u.searchParams.delete('ausstellung');
          u.hash = '';
          return u.pathname + '?' + u.searchParams.toString();
        } catch (e) { return String(url); }
      };

      /* Filterwechsel ohne Seitensprung: nur Raster und Farbkreise werden getauscht */
      let rendered = stripped(location.href);
      let busy = false;
      const load = (url, keepShow, push) => {
        if (!canFetch || busy) return Promise.resolve(false);
        busy = true;
        this.setAttribute('data-busy', '');
        return fetch(url, { credentials: 'same-origin' })
          .then(res => { if (!res.ok) throw new Error(res.status); return res.text(); })
          .then(text => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const freshResults = doc.querySelector('[data-results]');
            const freshPick = doc.querySelector('.tmg-pick');
            const oldResults = pick('[data-results]');
            const oldPick = pick('.tmg-pick');
            if (!freshResults || !oldResults) throw new Error('Kein Raster gefunden');
            oldResults.replaceWith(freshResults);
            if (freshPick && oldPick) oldPick.replaceWith(freshPick);
            paintSwatches();
            this.querySelectorAll('[data-card]').forEach(card => card.classList.add('is-in'));
            if (push !== false) { try { history.pushState({ tmg: 1 }, '', url); } catch (e) {} }
            syncSwatches();
            rendered = stripped(url);
            applyShow(Boolean(keepShow));
            return true;
          })
          .catch(() => false)
          .then(okay => { busy = false; this.removeAttribute('data-busy'); return okay; });
      };

      on(this, 'click', ev => {
        if (ev.defaultPrevented || ev.button || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
        const target = ev.target;
        if (!target || !target.closest) return;

        const filterLink = target.closest('[data-filter-link]');
        if (filterLink) {
          const url = filterLink.getAttribute('href');
          if (!url || !canFetch) return;
          ev.preventDefault();
          const isPage = Boolean(filterLink.closest('.tmg-pagination'));
          load(url, false, true).then(okay => {
            if (!okay) { location.assign(url); return; }
            if (isPage && anchor) anchor.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
          });
          return;
        }

        const toggle = target.closest('[data-show-toggle]');
        if (toggle) {
          const showGrid = pick('[data-show-grid]');
          if (!showGrid || !showGrid.children.length) return;
          const open = showGrid.hidden;
          const url = open ? toggle.dataset.urlOn : toggle.dataset.urlOff;
          ev.preventDefault();
          const jump = () => { if (open && anchor) anchor.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' }); };
          if (open && colourPicked() && canFetch) {
            load(url, true, true).then(okay => { if (okay) jump(); else location.assign(url); });
            return;
          }
          applyShow(open);
          try { history.pushState({ tmgShow: open }, '', url); } catch (e) {}
          jump();
        }
      });

      on(window, 'popstate', () => {
        if (stripped(location.href) === rendered) { applyShow(showWanted()); return; }
        load(location.href, showWanted(), false).then(okay => { if (!okay) location.reload(); });
      });

      if (showWanted()) applyShow(true);

      /* ---------- Parallax (mehrere Flächen, ohne Ruckeln) ---------- */
      const panels = [...this.querySelectorAll('[data-parallax]')];
      const active = new Set();
      const paint = () => {
        this.frame = 0;
        if (reduced.matches) return;
        const vh = innerHeight;
        active.forEach(panel => {
          const box = panel.getBoundingClientRect();
          const shift = Math.max(-46, Math.min(46, (vh / 2 - box.top - box.height / 2) * 0.09));
          panel.style.setProperty('--tmg-par', shift.toFixed(1) + 'px');
        });
      };
      const schedule = () => { if (active.size && !reduced.matches && !this.frame) this.frame = requestAnimationFrame(paint); };
      if (panels.length && 'IntersectionObserver' in window) {
        this.parallax = new IntersectionObserver(entries => {
          entries.forEach(entry => entry.isIntersecting ? active.add(entry.target) : active.delete(entry.target));
          schedule();
        }, { rootMargin: '120px 0px' });
        panels.forEach(p => this.parallax.observe(p));
        on(window, 'scroll', schedule);
        on(window, 'resize', schedule);
      }
      on(reduced, 'change', () => {
        if (!reduced.matches) { schedule(); return; }
        cancelAnimationFrame(this.frame); this.frame = 0;
        panels.forEach(p => p.style.removeProperty('--tmg-par'));
        targets.forEach(el => el.classList.add('is-in'));
      });
    }
    cleanup() {
      if (this.events) this.events.abort();
      if (this.reveal) this.reveal.disconnect();
      if (this.filmWatch) this.filmWatch.disconnect();
      if (this.parallax) this.parallax.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
    disconnectedCallback() {
      this.cleanup();
      this.querySelectorAll('video').forEach(v => v.pause());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiamont-sicis-kateg"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tiamont-sicis-mosaic')) {
  customElements.define('tiamont-sicis-mosaic', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.signal = this.abort.signal;
      this.animations = new Set();
      this.seen = new WeakSet();
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) this.animations.forEach(animation => animation.cancel());
        this.updateParallax();
      }, { signal: this.signal });
      this.setupMotion();
      this.setupPlayer();
      this.addEventListener('click', event => this.followAnchor(event), { signal: this.signal });
      this.querySelectorAll('.sx-faq details').forEach(item => item.addEventListener('toggle', () => {
        if (item.open && this.motion) this.animateElement(item.querySelector('p'), [{ opacity: 0, transform: 'translateY(5px)' }, { opacity: 1, transform: 'none' }], { duration: 340 });
      }, { signal: this.signal }));
    }
    get motion() {
      return this.dataset.sxMotion === 'true' && !this.reduced.matches;
    }
    animateElement(element, frames, options = {}) {
      if (!element || !element.animate || !this.motion) return;
      const animation = element.animate(frames, { duration: 850, easing: 'cubic-bezier(.2,.65,.3,1)', fill: 'backwards', ...options });
      this.animations.add(animation);
      animation.finished.then(() => this.animations.delete(animation), () => this.animations.delete(animation));
    }
    setupMotion() {
      const hero = this.querySelector('.sx-hero');
      if (this.motion && hero.getBoundingClientRect().top < window.innerHeight && window.scrollY < 250) {
        this.animateElement(this.querySelector('.sx-hero__copy'), [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 1000 });
        this.animateElement(this.querySelector('.sx-film-shell'), [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 1050, delay: 100 });
      }
      if ('IntersectionObserver' in window) {
        this.revealObserver = new IntersectionObserver(entries => {
          let order = 0;
          entries.forEach(entry => {
            if (!entry.isIntersecting || this.seen.has(entry.target)) return;
            this.seen.add(entry.target);
            this.revealObserver.unobserve(entry.target);
            if (entry.boundingClientRect.bottom <= 60 || !this.motion) return;
            const delay = entry.target.closest('[data-sx-stagger]') ? Math.min(order++ * 80, 240) : 0;
            this.animateElement(entry.target, [{ opacity: 0, transform: 'translateY(22px)' }, { opacity: 1, transform: 'none' }], { delay });
            const crop = entry.target.querySelector('.sx-detail-crop');
            if (crop) this.animateElement(crop, [{ clipPath: 'inset(6% 0 0 0)' }, { clipPath: 'inset(0 0 0 0)' }], { duration: 1100, delay });
          });
        }, { threshold: 0.06, rootMargin: '0px 0px -25px 0px' });
        this.querySelectorAll('[data-sx-reveal]').forEach(element => this.revealObserver.observe(element));
      }
      this.parallaxScene = this.querySelector('[data-sx-parallax-scene]');
      this.parallaxLayer = this.querySelector('[data-sx-parallax-layer]');
      const schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.updateParallax(); });
      };
      window.addEventListener('scroll', schedule, { passive: true, signal: this.signal });
      window.addEventListener('resize', schedule, { passive: true, signal: this.signal });
      this.updateParallax();
    }
    updateParallax() {
      if (!this.parallaxScene || !this.parallaxLayer) return;
      if (!this.motion || this.dataset.sxParallax !== 'true') {
        this.parallaxLayer.style.transform = 'none';
        return;
      }
      const bounds = this.parallaxScene.getBoundingClientRect();
      if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;
      const progress = Math.max(-1, Math.min(1, (bounds.top + bounds.height / 2 - window.innerHeight / 2) / ((window.innerHeight + bounds.height) / 2)));
      const travel = window.innerWidth <= 540 ? 23 : 38;
      this.parallaxLayer.style.transform = `translate3d(0,${(progress * travel).toFixed(2)}px,0)`;
    }
    followAnchor(event) {
      const link = event.target.closest('a[href^="#sx-"]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target || !this.contains(target)) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: this.motion ? 'smooth' : 'instant', block: 'start' });
      const focus = target.querySelector('h2,h3') || target;
      const tabindex = focus.getAttribute('tabindex');
      focus.setAttribute('tabindex', '-1');
      focus.focus({ preventScroll: true });
      focus.addEventListener('blur', () => { if (tabindex === null) focus.removeAttribute('tabindex'); else focus.setAttribute('tabindex', tabindex); }, { once: true, signal: this.signal });
      try { history.replaceState(null, '', link.getAttribute('href')); } catch (_) {}
    }
    setupPlayer() {
      this.film = this.querySelector('[data-sx-film]');
      this.video = this.film.querySelector('video');
      this.playButton = this.querySelector('[data-sx-play]');
      this.playLabel = this.querySelector('[data-sx-play-label]');
      this.fullButton = this.querySelector('[data-sx-fullscreen]');
      this.dialog = this.querySelector('[data-sx-fullscreen-dialog]');
      this.videoStatus = this.querySelector('[data-sx-video-status]');
      this.videoFallback = this.querySelector('[data-sx-video-fallback]');
      this.labels = { play: this.dataset.sxPlay, pause: this.dataset.sxPause, load: this.dataset.sxLoad, error: this.dataset.sxError, fullOpen: this.dataset.sxFullOpen, fullClose: this.dataset.sxFullClose };
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.playButton.addEventListener('click', () => this.togglePlayback(), { signal: this.signal });
      this.fullButton.addEventListener('click', () => this.toggleFullscreen(), { signal: this.signal });
      this.video.addEventListener('playing', () => {
        this.playPending = false;
        this.film.dataset.started = 'true';
        this.videoStatus.textContent = '';
        this.videoFallback.hidden = true;
        this.syncPlayback();
      }, { signal: this.signal });
      this.video.addEventListener('pause', () => this.syncPlayback(), { signal: this.signal });
      this.video.addEventListener('waiting', () => { if (!this.video.paused) this.videoStatus.textContent = this.labels.load; }, { signal: this.signal });
      this.video.addEventListener('error', () => this.showVideoError(), { signal: this.signal });
      this.video.addEventListener('volumechange', () => { if (!this.video.muted) this.video.muted = true; }, { signal: this.signal });
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.video.pause(); }, { signal: this.signal });
      document.addEventListener('fullscreenchange', () => this.syncFullscreen(), { signal: this.signal });
      this.dialog.addEventListener('close', () => this.restoreFilm(), { signal: this.signal });
      if ('IntersectionObserver' in window) {
        this.playerObserver = new IntersectionObserver(entries => {
          if (!entries[0].isIntersecting && document.fullscreenElement !== this.film && !this.dialog.open) this.video.pause();
        }, { threshold: 0 });
        this.playerObserver.observe(this.film);
      }
      this.querySelector('[data-sx-controls]').hidden = false;
      this.syncPlayback();
    }
    async togglePlayback() {
      if (!this.video.paused || this.playPending) {
        this.playPending = false;
        this.video.pause();
        this.videoStatus.textContent = '';
        this.syncPlayback();
        return;
      }
      if (!this.video.hasAttribute('src') || this.video.error) {
        this.video.src = this.video.dataset.sxSrc;
        this.video.load();
      }
      this.playPending = true;
      this.video.muted = true;
      this.videoStatus.textContent = this.labels.load;
      this.syncPlayback();
      try {
        await this.video.play();
      } catch (error) {
        this.playPending = false;
        if (error.name !== 'AbortError') this.showVideoError();
        this.syncPlayback();
      }
    }
    syncPlayback() {
      const playing = !this.video.paused || this.playPending;
      this.film.dataset.playing = playing ? 'true' : 'false';
      this.playButton.setAttribute('aria-label', playing ? this.labels.pause : this.labels.play);
      this.playLabel.textContent = playing ? this.labels.pause : this.labels.play;
    }
    showVideoError() {
      this.playPending = false;
      this.videoStatus.textContent = this.labels.error;
      this.videoFallback.hidden = false;
      this.syncPlayback();
    }
    async toggleFullscreen() {
      if (this.dialog.open) { this.dialog.close(); return; }
      if (document.fullscreenElement === this.film) { await document.exitFullscreen(); return; }
      if (this.film.requestFullscreen) {
        try { await this.film.requestFullscreen(); return; } catch (_) {}
      }
      this.placeholder = document.createElement('span');
      this.placeholder.hidden = true;
      this.film.before(this.placeholder);
      this.dialog.append(this.film);
      this.dialog.showModal();
      this.syncFullscreen();
      this.fullButton.focus();
    }
    restoreFilm() {
      if (this.placeholder) {
        this.placeholder.replaceWith(this.film);
        this.placeholder = null;
      }
      this.syncFullscreen();
      if (this.isConnected) this.fullButton.focus({ preventScroll: true });
    }
    syncFullscreen() {
      const active = document.fullscreenElement === this.film || this.dialog.open;
      this.fullButton.setAttribute('aria-label', active ? this.labels.fullClose : this.labels.fullOpen);
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      if (this.placeholder) this.restoreFilm();
      this.video?.pause();
      this.abort?.abort();
      this.revealObserver?.disconnect();
      this.playerObserver?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.abort = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
